// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"4686045e","239":"2f822dd7","455":"613fd633","977":"1ff7fdd1"}[chunkId] + ".chunk.js";
};